import { render, staticRenderFns } from "./Error460.vue?vue&type=template&id=963b81e6&scoped=true&"
import script from "./Error460.vue?vue&type=script&lang=js&"
export * from "./Error460.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963b81e6",
  null
  
)

export default component.exports